module.exports = __webpack_public_path__ + "static/media/Achilles.9669440b.jpg";